import { ConditionType, type IConditionDto, ConditionBase, ConditionState, type IConditionLabelOptions, type IVehicle, ConfigurationType } from "..";

export class RecallCondition extends ConditionBase
{

    constructor( vehicle: IVehicle, model: IConditionDto )
    {
        super( vehicle, model, ConditionType.Recall, ConfigurationType.None, false );
        this.icon = 'dashboard:recall';
        this.ordinal = 0;
        this.initialise();
    }

    /**
     * Gets the labels for the condition.  The labels are used to provide meaningful
     * user interface statements/prompts that are specific to the condition
     */
    override getLabels(): IConditionLabelOptions 
    {
        return {
            name: "Recall",
            shortName: 'Recall',
            longName: "Recall Notice",
            intervalJustCompletedMessage: "Recall fix was just completed",
            cta: "Book a service/fix",
            description: 'A recall has been issued on your vehicle. You should make a booking with your dealership as soon as possible to have it repaired',
            maintenanceVerb: 'Recall',
            protectedByLabel: 'Your car is protected by'
        };
    }

    /**
     * Gets the description for the interval update for this condition
     * @returns 
     */
    protected override getIntervalDescription()
    {
        return 'n/a';
    }

    /**
     * Gets the action message for the service note
     */
    override getActionMessage() 
    {
        switch( this.state )
        {
            case ConditionState.Due: return 'You have a recall notice, book an appointment as soon as possible';
            case ConditionState.Overdue: return 'You have a recall notice, book an appointment as soon as possible';
            case ConditionState.Critical: return 'You have a recall notice, book an appointment as soon as possible';
            default: return '';
        }
    }
    
}
